module.exports = __webpack_public_path__ + "static/Portrait-of-Kasper-min-218d75d75a66f609ee13c14565417f46.webp";